/**
 * Extracts a clean CSS color value from the internal "Label color" storage
 * format used by SelectColorInput (e.g. "White rgb(255,255,255)" or
 * "custom #470500").  Returns the bare color token so it can be safely used
 * as a CSS value or stored in the API payload.
 *
 * Handles:
 *   "Label rgb(...)"  → "rgb(...)"
 *   "Label #xxxxxx"   → "#xxxxxx"
 *   "#xxxxxx"         → "#xxxxxx"   (already clean)
 *   "rgb(...)"        → "rgb(...)"  (already clean)
 *   "default"         → fallback
 *   null / undefined  → fallback
 */
export function extractColorValue(value, fallback = "#FFFFFF") {
  if (!value || value === "default") return fallback;

  const match = value.match(/^(?:.+?\s+)?(rgb\([^)]+\)|#[0-9A-Fa-f]{3,8})$/);
  if (match) return match[1];

  // If it looks like a raw hex or rgb with no label prefix, return as-is
  if (/^(rgb\(|#)/.test(value)) return value;

  return fallback;
}
